import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import WaveLoader from '@/components/WaveLoader';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <WaveLoader label="Tuning in" />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Email-lead users are scoped to Confidence flows + Player only
  if (user.auth_provider === 'email_lead') {
    const path = location.pathname;
    const allowedPrefixes = ['/confidence', '/player/'];
    if (!allowedPrefixes.some(p => path.startsWith(p))) {
      return <Navigate to="/confidence/library" replace />;
    }
  }

  return children;
}
